'use strict';

angular.module('DoohApps').service('AccountService', ['$rootScope', '$routeParams', '$uibModal', '$location', 'accountBLL', 'AppStoreDataFilter', 'CampaignDataFilter', 'SessionData', 'DialogHandler', 'Hub', 'SessionHelper', 'User', 'DoohConfig', 'modal2',
    function ($rootScope, $routeParams, $uibModal, $location, accountBLL, AppStoreDataFilter, CampaignDataFilter, SessionData, DialogHandler, Hub, SessionHelper, User, DoohConfig, modal2) {
        this.openLoginModal = function () {
            var modalObj = {
                name: 'Login',
                windowClass: 'loginModal simpleFormModal',
                finallyCallback: function (data) {
                    $(window).capslockstate('destroy');
                    $(window).off('capsChanged');
                }
            }
            modal2.open(modalObj);

            SessionData.setLoginRequired(false);
        }

        this.openRegistrationModal = function () {
            var modalObj = {
                name: 'Register',
                finallyCallback: function (data) {
                    $location.path('/AppStore', false);
                }
            }
            modal2.open(modalObj);
        }

        this.openRegistrationFinishModal = function () {
            accountBLL.getUserByInviteCode(function (data) {
                if (data.hasError) {
                    DialogHandler.AddError(data.error);
                } else {
                    var modalObj = {
                        name: 'RegisterStepTwo',
                        windowClass: 'registrationModal',
                        finallyCallback: function (data) {
                            $location.search('registrationCode', null);
                            $location.path('/AppStore', localStorage.getItem('accessToken') != null);
                        },
                        passObj: { regUser: data.content }
                    }
                    modal2.open(modalObj);
                }
            }, {
                    code: $routeParams.registrationCode,
                    purpose: 'registration'
                });
        }

        this.logout = function () {
            accountBLL.logout(function () {
                User.clear();
                clearFilters();
                Hub.Stop();
                SessionData.clearReturnURL();
                $rootScope.goto('/AppStore');
            });
        }

        this.openPopupForPasswardRenewall = function () {
            let val = $routeParams.guid;

            if (typeof val != 'undefined' && val != '') {
                var modalObj = {
                    name: 'RenewPassword',
                    windowClass: 'loginModal simpleFormModal',
                    passObj: {
                        guid: val
                    }
                }
                modal2.open(modalObj);
            }
        }

        $rootScope.loginPressed = false;

        this.checkToolboxAccess = function () {
            if (!User.isLoggedIn && !($location.path() === '/' || $location.path() === '/AppStore')) {
                SessionData.setReturnURL();
                $location.path('/AppStore');
                sessionStorage.setItem('loginRequired', true);
                return { hasAccess: false };
            }
            return { hasAccess: true };
        }

        var clearFilters = function () {
            AppStoreDataFilter.Clear();
            CampaignDataFilter.Clear();
            if ($rootScope.hideFiltersOnLogInLogOut)
                $rootScope.hideFiltersOnLogInLogOut();
        }
    }]);